export default __webpack_public_path__ + "1893508d8e1759cda6edc4c7c4596757.svg";